module.exports = __webpack_public_path__ + "static/media/th-circle.1c9dfa4c.svg";